import { useEffect, useState } from "react";
import KinAvatar from "./KinAvatar";

/**
 * Kin is working. Pulsing dots, and optionally a line of words that changes
 * every couple of seconds.
 *
 * ⚠️ HOUSE RULE (Kasandra, Nov 2 2026): any wait longer than a beat shows
 * motion. A static "Reading your sheet…" bubble looked frozen on her phone and
 * read as broken. If Kin is thinking, something on screen moves, and when
 * the wait has words they change (the way Claude's do), so ten seconds of the
 * same sentence never looks like a hang. Use this component rather than a
 * plain text message for any placeholder that waits on a network call.
 */
const PHRASE_MS = 2200;

const TypingIndicator = ({ phrases }: { phrases?: readonly string[] }) => {
  const [i, setI] = useState(0);
  const list = phrases && phrases.length > 0 ? phrases : null;

  useEffect(() => {
    if (!list || list.length < 2) return;
    const t = window.setInterval(() => setI((n) => Math.min(n + 1, list.length - 1)), PHRASE_MS);
    return () => window.clearInterval(t);
  }, [list]);

  return (
    <div className="flex items-end gap-2.5 animate-fade-slide-in" data-testid="kin-thinking" role="status" aria-live="polite">
      <KinAvatar size="sm" variant="light" />
      <div className="bg-card rounded-[18px] rounded-bl-[4px] px-4 py-3 shadow-kin-light flex items-center gap-2.5">
        <div className="flex items-center gap-1.5" aria-hidden="true">
          {[0, 1, 2].map((d) => (
            <div
              key={d}
              className="w-2 h-2 rounded-full bg-kin-soft-violet animate-dot-pulse"
              style={{ animationDelay: `${d * 0.2}s` }}
            />
          ))}
        </div>
        {list && (
          <span key={i} className="font-body text-sm animate-fade-slide-in" style={{ color: "#54525C" }}>
            {list[i]}
          </span>
        )}
      </div>
    </div>
  );
};

export default TypingIndicator;
